import React, { useMemo } from 'react';

import { ProductDetailsTopProducts } from '@components/product/ProductDetailsTopProducts';
import { ProductsFeedSleketon } from '@components/ProductsFeedSleketon';
import { convertProductProps } from '@utils/products';

import { useProductDetailsTopProductsQuery } from './gql/graphql.v3.generated';

interface Props {
  className?: string,
  productId: number,
}

export const ProductDetailsTopProductsContainer: React.FC<Props> = ({
  className,
  productId,
}) => {
  const { data, loading } = useProductDetailsTopProductsQuery({
    variables: {
      productId,
      perPage: 8,
    },
    context: {
      batch: true,
    },
  });

  const products = useMemo(() => {
    return data?.productDetailsTopProducts?.map((product) => {
      if (product) {
        return convertProductProps(product);
      }

      return null;
    }).filter((product) => !!product);
  }, [data?.productDetailsTopProducts]);

  if (loading) {
    return (
      <div className={className}>
        <ProductsFeedSleketon count={4} />
      </div>
    );
  }

  if (products?.length) {
    return (
      <ProductDetailsTopProducts
        className={className}
        products={products}
      />
    );
  }

  return null;
};
